import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import ContainerSpinner from "../../../components/Loaders/ContainerSpinner";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";

import ClosedInvoicesTable from "src/components/Billecta/Invoices/ClosedInvoicesTable";

export default function ClosedInvoices() {
  const dispatch = useDispatch();

  const { creditorId } = useParams();

  const closedInvoices = useSelector(
    (state) => state.billectaInvoicing.closedInvoices
  );

  return (
    <DetailInnerWrapper>
      <DetailPageBox>
        <OverviewTitleWrapper>
          <OverviewTitle>Stängda Fakturor</OverviewTitle>
        </OverviewTitleWrapper>

        <ClosedInvoicesTable creditorId={creditorId} />
      </DetailPageBox>
    </DetailInnerWrapper>
  );
}
